import { render } from "./AuthFooterModal.vue?vue&type=template&id=4047e198&scoped=true"
import script from "./AuthFooterModal.vue?vue&type=script&lang=js"
export * from "./AuthFooterModal.vue?vue&type=script&lang=js"

import "./AuthFooterModal.vue?vue&type=style&index=0&id=4047e198&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4047e198"]])

export default __exports__